import { FC, useState } from 'react';
import DropdownWithSearch from 'components/dropdown-with-search/DropdownWithSearch';
import { joinTextArray } from 'utils/commonUtils';
import { pluckValuesFromArrayWithSpecificKey } from 'utils/formatters';
import { CrossIcon } from 'assets/icons';
import { PlusIcon } from 'assets/icons';

export const ActionList = {
  status: 'Job Status',
  assignee: 'Assigned Team',
  schedule: 'Job Schedule',
  lineItem: 'Line Items',
  adjustments: 'Pay Adjustments'
} as const;

export const BaseFilter = {
  NOTE: 'Notes',
  ATTACHMENTS: 'Attachments'
};

export type HistoryActionTypes = typeof ActionList[keyof typeof ActionList];

interface JobDetailHistoryFilterProps {
  selectedActions: string[];
  onSelectActions: (actions: string[]) => void;
  selectedBaseFilter: string[];
  onSelectBaseFilter: (baseFilter: string[]) => void;
}

const JobDetailHistoryFilter: FC<JobDetailHistoryFilterProps> = ({
  selectedActions,
  onSelectActions,
  selectedBaseFilter,
  onSelectBaseFilter
}) => {
  const [actionsDraft, setActionsDraft] = useState<string[]>([]);

  const actionOptions = Object.entries(ActionList).map(([key, label]) => ({
    id: key,
    label: label,
    value: key
  }));

  const getTextForFilter = () => {
    return joinTextArray(
      pluckValuesFromArrayWithSpecificKey(
        actionOptions.filter(item => selectedActions.includes(item.value)),
        'label'
      )
    );
  };

  const handleActionsChange = (selected: string[]) => {
    onSelectActions(selected);
  };

  return (
    <div className="flex gap-x-2">
      {Object.entries(BaseFilter)?.map(([key, label]) => (
        <div
          key={key}
          className={`shrink-0 cursor-pointer rounded-md border 
                bg-primary px-3 py-2 text-sbase font-semibold text-primaryText  
                outline-none transition-all  duration-150 ease-linear focus:outline-none 
                ${selectedBaseFilter?.includes(key) ? ' border-solid bg-secondaryBtn' : 'border-dashed'} `}
          id={key}
          style={{ borderColor: '#ACB5BD' }}
          onClick={() => {
            if (selectedBaseFilter?.includes(key)) {
              onSelectBaseFilter(selectedBaseFilter.filter(item => item !== key));
            } else {
              onSelectBaseFilter([...selectedBaseFilter, key]);
            }
          }}>
          <div className={'flex shrink-0 flex-row items-center'}>
            <div>
              {selectedBaseFilter?.includes(key) ? (
                <CrossIcon
                  onClick={e => {
                    e.stopPropagation();
                    onSelectBaseFilter(selectedBaseFilter.filter(item => item !== key));
                  }}
                />
              ) : (
                <PlusIcon />
              )}
            </div>
            <div
              id={`${key}-text`}
              className={`shrink-0 px-3 text-sbase ${
                selectedBaseFilter?.includes(key) ? 'text-[#3876BB]' : 'text-primaryText'
              }`}>
              {label}
            </div>
          </div>
        </div>
      ))}
      <DropdownWithSearch
        data={actionOptions}
        dataKey="label"
        dataIdKey="value"
        selectedDraftArray={actionsDraft}
        setSelectedDraftArray={setActionsDraft}
        selectedArray={selectedActions}
        setSelectedArray={handleActionsChange}
        buttonPrimaryText="Actions"
        buttonSecondaryText={getTextForFilter()}
        filterPlaceholderText="Filter by actions"
        allowSearch={false}
        showResultsCount={false}
        filterId="history-tab-action-filter"
        filterPlaceholderStyle="font-semibold"
        customClassName="w-full whitespace-nowrap"
      />
    </div>
  );
};

export default JobDetailHistoryFilter;
